import React, { useEffect, useState } from "react";
import AppLayout from "../components/AppLayout";
import { api, errMsg } from "../lib/api";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function RolesPage() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [custom, setCustom] = useState([]); // custom field keys
  const [newField, setNewField] = useState("");

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/roles"); setRoles(data); const keys = new Set(); data.forEach(r => Object.keys(r.custom_fields||{}).forEach(k=>keys.add(k))); setCustom([...keys]); }
    catch(e){ toast.error(errMsg(e)); }
    setLoading(false);
  };
  useEffect(()=>{ load(); }, []);

  const add = async () => {
    try { const { data } = await api.post("/roles", { data: { name:"New Role", function:"", rate:0, other_details:"", custom_fields: Object.fromEntries(custom.map(k=>[k,""])) }}); setRoles((x)=>[data, ...x]); }
    catch(e){ toast.error(errMsg(e)); }
  };
  const update = async (id, patch) => {
    setRoles((xs)=>xs.map(r=>r.id===id?{...r,...patch}:r));
    try { await api.put(`/roles/${id}`, { data: patch }); } catch(e){ toast.error(errMsg(e)); }
  };
  const remove = async (id) => {
    if (!window.confirm("Delete role?")) return;
    try { await api.delete(`/roles/${id}`); setRoles((xs)=>xs.filter(r=>r.id!==id)); } catch(e){ toast.error(errMsg(e)); }
  };
  const addField = () => {
    const n = newField.trim(); if (!n) return;
    setCustom((x)=>[...x, n]); setNewField("");
    toast.success(`Column "${n}" added`);
  };

  return (
    <AppLayout>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-white" style={{fontFamily:'Outfit'}}>Roles</h1>
          <p className="text-slate-400 mt-1">Define roles and hourly rates used across projects.</p>
        </div>
        <div className="flex gap-2">
          <div className="flex gap-1">
            <input value={newField} onChange={(e)=>setNewField(e.target.value)} placeholder="Custom field name" data-testid="custom-field-input"
              className="px-3 py-2 rounded-lg border focus:outline-none focus:border-blue-500 text-sm"/>
            <button onClick={addField} data-testid="add-custom-role-field-btn" className="border border-slate-700 hover:border-blue-500 text-slate-200 px-3 py-2 rounded-lg text-sm">+ Field</button>
          </div>
          <button onClick={add} data-testid="add-role-btn" className="bg-gradient-to-r from-blue-500 to-blue-700 text-white px-4 py-2 rounded-lg inline-flex items-center gap-2"><Plus size={14}/> New role</button>
        </div>
      </div>
      <div className="pc-card overflow-x-auto" data-testid="roles-table">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-widest text-blue-300/80 border-b border-slate-800">
            <tr>
              <th className="p-3">Role</th>
              <th className="p-3">Function</th>
              <th className="p-3">Rate ($/hr)</th>
              <th className="p-3">Other details</th>
              {custom.map((c)=> <th key={c} className="p-3">{c}</th>)}
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800/60">
            {loading ? <tr><td className="p-6 text-slate-400">Loading…</td></tr>
              : roles.length===0 ? <tr><td colSpan={5+custom.length} className="p-10 text-center text-slate-400">No roles yet. Add your first role.</td></tr>
              : roles.map(r=> (
                <tr key={r.id} data-testid={`role-row-${r.id}`}>
                  <td className="p-2"><input value={r.name||""} onChange={(e)=>update(r.id,{name:e.target.value})} className="w-full bg-transparent border border-transparent hover:border-slate-700 focus:border-blue-500 rounded px-2 py-1 outline-none"/></td>
                  <td className="p-2"><input value={r.function||""} onChange={(e)=>update(r.id,{function:e.target.value})} className="w-full bg-transparent border border-transparent hover:border-slate-700 focus:border-blue-500 rounded px-2 py-1 outline-none"/></td>
                  <td className="p-2 w-32"><input type="number" value={r.rate||0} onChange={(e)=>update(r.id,{rate:Number(e.target.value||0)})} className="w-full bg-transparent border border-transparent hover:border-slate-700 focus:border-blue-500 rounded px-2 py-1 outline-none"/></td>
                  <td className="p-2"><input value={r.other_details||""} onChange={(e)=>update(r.id,{other_details:e.target.value})} className="w-full bg-transparent border border-transparent hover:border-slate-700 focus:border-blue-500 rounded px-2 py-1 outline-none"/></td>
                  {custom.map((c)=> (
                    <td key={c} className="p-2"><input value={(r.custom_fields||{})[c]||""} onChange={(e)=>update(r.id,{custom_fields:{...(r.custom_fields||{}),[c]:e.target.value}})} className="w-full bg-transparent border border-transparent hover:border-slate-700 focus:border-blue-500 rounded px-2 py-1 outline-none"/></td>
                  ))}
                  <td className="p-2"><button onClick={()=>remove(r.id)} className="text-slate-500 hover:text-rose-400" data-testid={`delete-role-${r.id}`}><Trash2 size={14}/></button></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </AppLayout>
  );
}
